"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _reactRouter = require("react-router");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UserSearchPopup(_ref) {
  var onSelected = _ref.onSelected,
    onClose = _ref.onClose,
    fixed = _ref.fixed,
    companyId = _ref.companyId,
    excludeSessionUser = _ref.excludeSessionUser;
  var _a, _b, _c, _d;
  var qs = (0, _reactRouter.useLocation)().search;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(qs);
  }, [qs]);
  var params = (0, _commons.useSearchParams)(query);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var tenantId = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id;
  var userId = (_d = (_c = (_b = context.session) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '';
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    users = _useState4[0],
    setUsers = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    total = _useState6[0],
    setTotal = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedIds = _useState8[0],
    setSelectedIds = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedUsers = _useState10[0],
    setSelectedUsers = _useState10[1];
  var disabled = (0, _react.useMemo)(function () {
    if (excludeSessionUser) {
      return [userId];
    }
    return [];
  }, [excludeSessionUser, userId]);
  var grantedUsers = (0, _react.useMemo)(function () {
    return context.isGrantedAny(['PUsersRead', 'TUsersRead']);
  }, [context]);
  var companyIds = (0, _react.useMemo)(function () {
    if (!companyId) return [];
    return [companyId];
  }, [companyId]);
  var clearCallback = (0, _react.useCallback)(function () {
    setUsers([]);
    setTotal(0);
  }, []);
  var _usePagination = (0, _commons.usePagination)(clearCallback),
    page = _usePagination.page,
    pageSize = _usePagination.pageSize,
    onChangedPage = _usePagination.onChangedPage,
    onChangedPageSize = _usePagination.onChangedPageSize;
  var retrievePromise = (0, _react.useCallback)(function () {
    var offset = (0, _commons.getOffset)(page, pageSize);
    var fixedParams = Object.assign(Object.assign({}, params), {
      page: pageSize,
      offset: offset,
      companyIds: companyIds
    });
    if (tenantId) {
      return (0, _api.safeListUsers)(tenantId, fixedParams, {
        access: access
      });
    }
    if (grantedUsers) {
      return (0, _api.listUsers)(fixedParams, {
        access: access,
        tenantId: tenantId
      });
    }
    return (0, _api.emptyPromise)();
  }, [access, tenantId, companyIds, grantedUsers, params, page, pageSize]);
  var fixedPromise = (0, _react.useCallback)(function () {
    if (fixed.length === 0) {
      return (0, _api.emptyPromise)();
    }
    var params = {
      companyIds: companyIds,
      ids: fixed,
      page: 0,
      offset: 0
    };
    if (tenantId) {
      return (0, _api.safeListUsers)(tenantId, params, {
        access: access
      });
    }
    if (grantedUsers) {
      return (0, _api.listUsers)(params, {
        access: access,
        tenantId: tenantId
      });
    }
    return (0, _api.emptyPromise)();
  }, [access, tenantId, companyIds, grantedUsers, fixed]);
  var reload = (0, _react.useCallback)(function () {
    setUsers([]);
    setTotal(0);
    setStatus('loading');
    retrievePromise().then(function (response) {
      var _a, _b;
      setUsers((_a = response === null || response === void 0 ? void 0 : response.items) !== null && _a !== void 0 ? _a : []);
      setTotal((_b = response === null || response === void 0 ? void 0 : response.count) !== null && _b !== void 0 ? _b : 0);
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error);
    });
  }, [retrievePromise]);
  (0, _react.useEffect)(function () {
    fixedPromise().then(function (response) {
      var _a, _b;
      setSelectedIds((_a = response === null || response === void 0 ? void 0 : response.items.map(function (el) {
        return el.id;
      })) !== null && _a !== void 0 ? _a : []);
      setSelectedUsers((_b = response === null || response === void 0 ? void 0 : response.items) !== null && _b !== void 0 ? _b : []);
    });
  }, [fixedPromise]);
  (0, _react.useEffect)(reload, [reload]);
  var onChanged = function onChanged(ids, users) {
    if (ids.length === users.length) {
      setSelectedUsers(users);
    } else {
      setSelectedUsers(function (curr) {
        var keep = curr.filter(function (u) {
          return ids.indexOf(u.id) !== -1;
        });
        var newUsers = users.filter(function (u) {
          return keep.findIndex(function (el) {
            return el.id === u.id;
          }) === -1;
        });
        return [].concat(_toConsumableArray(keep), _toConsumableArray(newUsers));
      });
    }
    setSelectedIds(ids);
  };
  var onDeleted = (0, _react.useCallback)(function (user) {
    return function () {
      setSelectedIds(function (curr) {
        return curr.filter(function (el) {
          return el !== user.id;
        });
      });
      setSelectedUsers(function (curr) {
        return curr.filter(function (el) {
          return el.id !== user.id;
        });
      });
    };
  }, []);
  var onSubmit = function onSubmit() {
    if (selectedUsers.length === 0) return;
    var people = selectedUsers.map(function (user) {
      return {
        user_id: user.id,
        name: user.name,
        email: user.email
      };
    });
    onSelected(people);
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    open: true,
    title: (0, _core.translate)('users.title'),
    button: {
      text: (0, _core.translate)('buttons.select'),
      onClick: onSubmit,
      disabled: selectedUsers.length === 0
    },
    onClose: onClose,
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_commons.Pagination, {
    title: (0, _core.translate)('users.title'),
    icon: /*#__PURE__*/_react["default"].createElement(_commons.UsersIcon, null),
    page: page,
    pageSize: pageSize,
    variant: "embeded",
    count: users ? users.length : 0,
    total: total,
    onChangedPage: onChangedPage,
    onChangedPageSize: onChangedPageSize
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    sx: {
      mb: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1"
  }, (0, _core.translate)('users.selected.title'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, selectedUsers.length === 0 && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2"
  }, (0, _core.translate)('users.selected.empty')), selectedUsers.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 1
  }, selectedUsers.map(function (el) {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      key: el.id,
      item: true,
      xs: "auto"
    }, /*#__PURE__*/_react["default"].createElement(_material.Chip, {
      label: el.name,
      variant: "filled",
      color: "primary",
      size: "small",
      deleteIcon: /*#__PURE__*/_react["default"].createElement(_commons.CloseIcon, null),
      onDelete: onDeleted(el)
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_commons.SearchFilter, {
    label: (0, _core.translate)('users.filter'),
    query: query
  }), /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined",
    sx: {
      mt: 0.5
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: users,
    getId: function getId(user) {
      return user.id;
    },
    loading: status === 'loading',
    error: status instanceof Error ? status.message : undefined,
    empty: (0, _core.translate)('users.empty'),
    selectable: {
      selected: selectedIds,
      disabled: disabled,
      onChange: onChanged
    },
    columns: [{
      title: (0, _core.translate)('users.name'),
      converter: function converter(item, index, indexRow) {
        return item.name;
      },
      id: 'name'
    }, {
      title: (0, _core.translate)('users.email'),
      converter: function converter(item, index, indexRow) {
        return item.email;
      },
      id: 'email'
    }]
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UserSearchPopup);